import classes from './Body.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Body(props) {
  let { children, className } = props;

  return <div className={classnames(classes.base, className)}>{children}</div>;
}

Body.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default Body;
